import { EmailTemplateRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createEmailTemplate: (
  fetchContext: FetchContext,
  programId: number,
  emailTemplate: EmailTemplateRequest,
  isForSending: boolean,
  isTemporary: boolean,
  accessToken?: string,
) => Promise<number> = async (fetchContext, programId, emailTemplate, isForSending, isTemporary, accessToken) => {
  const params = new URLSearchParams();
  params.append('isForSending', `${isForSending}`);
  params.append('isTemporary', `${isTemporary}`);

  const url = `${fetchContext.baseUrl}/api/staff/programs/${programId}/email-templates${params.size > 0 ? `?${params}` : ''}`;

  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(emailTemplate),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<number>(fetchContext.errorStore, response, 'create email template'));
};
